import {RecordTableColumnParams} from "../../../types/records-table.types";

export function filterOnlyFilterableParams(columnsParams: Array<RecordTableColumnParams>):  Array<RecordTableColumnParams> {
  return columnsParams.filter((param: RecordTableColumnParams) => param.filterable);
}
